import React, { useState } from "react";
import { GenericDialog } from "../../../generic/GenericDialog";
import { Interests } from "../../profileSetup/bio/Interests";
import { PlatformsAndSocials } from "./PlatformsAndSocials";
import { Box, Button, Stack } from "@mui/material";
import useStore from "../../../../states/store";
import { router, usePage } from "@inertiajs/react";
import { COLLAB_KEY } from "../../../../enums/generalEnums";
import { ProfessionsFilter } from "./ProfessionsFilter";

export const FilterTagsDialog = (props) => {
  const {
    openFilterAllTagsDialog,
    handleCloseFilterAllTags
  } = props;

  const { url } = usePage();
  const [, { setCreatorFilters, setPopularTag }] = useStore();
  const [collabInterestSelected, setCollabInterestSelected] = useState([]);
  const [contentInterestSelected, setContentInterestSelected] = useState([]);
  const [professionsSelected, setProfessionsSelected] = useState([]);
  const [platformsSelected, setPlatformsSelected] = useState([]);
  const [socialsSelected, setSocialsSelected] = useState([]);

  const handleApplyFilter = () => {
    setCreatorFilters({
      profession: professionsSelected,
      collab_interest: collabInterestSelected ?? [],
      content_interest: contentInterestSelected ?? [],
      category_values: [...platformsSelected, ...socialsSelected]
    });
    router.visit('/collab-creators');
    setPopularTag(COLLAB_KEY);
    handleCloseFilterAllTags();
  };

  const handleResetFilter = () => {
    setCreatorFilters({});
    setCollabInterestSelected([]);
    setContentInterestSelected([]);
    setPlatformsSelected([]);
    setSocialsSelected([]);
    setProfessionsSelected([]);
  };

  return (
    <GenericDialog
      title={'Select Tags'}
      width={'854px'}
      openDialog={openFilterAllTagsDialog}
      handleClose={handleCloseFilterAllTags}
    >
      <Box sx={{ overflowX: 'auto', paddingRight: '10px' }}>
        <Stack gap={1}>
          <ProfessionsFilter
            professionsSelected={professionsSelected}
            setProfessionsSelected={setProfessionsSelected}
          />
          <PlatformsAndSocials
            storeKey={'name'}
            platformsSelected={platformsSelected}
            socialsSelected={socialsSelected}
            setPlatformsSelected={setPlatformsSelected}
            setSocialsSelected={setSocialsSelected}
          />
          <Interests
            storeKey={'name'}
            collabInterestSelectedIds={collabInterestSelected}
            contentInterestSelectedIds={contentInterestSelected}
            setCollabInterestSelectedIds={setCollabInterestSelected}
            setContentInterestSelectedIds={setContentInterestSelected}
          />
        </Stack>
      </Box>
      <Stack gap={1} direction={'row'} justifyContent={'flex-end'} mt={2}>
        <Button variant="outlined" className="longButton" onClick={() => handleResetFilter()}>Reset Filter</Button>
        <Button variant="contained" className="longButton" onClick={() => handleApplyFilter()}>Apply Filter</Button>
      </Stack>
    </GenericDialog>
  );
};